// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-policy-terms-container {
  flex-grow: 1;
  flex-basis: 30rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.form-policy-terms-container button {
  padding: 0.4rem 1rem;
  border: 0;
  /* margin-top: 2rem; */
  border-radius: 0.4rem;
  cursor: pointer;
  font-size: 1.4rem;
  display: flex;
  justify-content: center;
  opacity: 0.7;
  background-color: white;
}
.form-policy-terms-container button:hover {
  opacity: 1;
}

.form-policy-terms-container span {
  font-size: 1.4rem;
  /* margin: 0 auto;
  margin-bottom: 2rem; */
}

.form-input-policy-terms {
  display: flex;
  flex-direction: column;
  position: relative;
  /* background-color: rgb(34,45,50); */
  padding: 0.2rem;
  border-radius: 0.4rem;
  gap: 1rem;
}

.form-input-policy-terms input {
  margin-bottom: 0.2rem;
}

.form-input-policy-terms input,
.form-input-policy-terms textarea {
  padding: 0.6rem 1rem;
  border: 0;
  font-size: 1.1rem;
  outline: 0;
  background-color: white;
}

.form-input-policy-terms textarea::selection,
.form-input-policy-terms input::selection {
  background-color: white
}

.form-input-policy-terms textarea::-webkit-scrollbar {
  width: 1rem;
  height: 1.125rem;
}

.form-input-policy-terms textarea::-webkit-scrollbar-corner {
  background-color: transparent;
}

.form-input-policy-terms textarea::-webkit-scrollbar-thumb {
  height: 0.375rem;
  background-clip: padding-box;
  border-radius: 0.5rem;
  background-color: white;
  box-shadow: inset -1px -1px 0px rgb(0 0 0 / 5%),
  inset 1px 1px 0px rgb(0 0 0 / 5%);
}

`, "",{"version":3,"sources":["webpack://./src/pages/private/Dashboard/pages/PolicyAndTerms/FormInput/index.modules.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB;wBACsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,SAAS;EACT,iBAAiB;EACjB,UAAU;EACV,uBAAuB;AACzB;;AAEA;;EAEE;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAE5B,qBAAqB;EACrB,uBAAuB;EAGvB;mCACiC;AACnC","sourcesContent":[".form-policy-terms-container {\n  flex-grow: 1;\n  flex-basis: 30rem;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.form-policy-terms-container button {\n  padding: 0.4rem 1rem;\n  border: 0;\n  /* margin-top: 2rem; */\n  border-radius: 0.4rem;\n  cursor: pointer;\n  font-size: 1.4rem;\n  display: flex;\n  justify-content: center;\n  opacity: 0.7;\n  background-color: white;\n}\n.form-policy-terms-container button:hover {\n  opacity: 1;\n}\n\n.form-policy-terms-container span {\n  font-size: 1.4rem;\n  /* margin: 0 auto;\n  margin-bottom: 2rem; */\n}\n\n.form-input-policy-terms {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  /* background-color: rgb(34,45,50); */\n  padding: 0.2rem;\n  border-radius: 0.4rem;\n  gap: 1rem;\n}\n\n.form-input-policy-terms input {\n  margin-bottom: 0.2rem;\n}\n\n.form-input-policy-terms input,\n.form-input-policy-terms textarea {\n  padding: 0.6rem 1rem;\n  border: 0;\n  font-size: 1.1rem;\n  outline: 0;\n  background-color: white;\n}\n\n.form-input-policy-terms textarea::selection,\n.form-input-policy-terms input::selection {\n  background-color: white\n}\n\n.form-input-policy-terms textarea::-webkit-scrollbar {\n  width: 1rem;\n  height: 1.125rem;\n}\n\n.form-input-policy-terms textarea::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n\n.form-input-policy-terms textarea::-webkit-scrollbar-thumb {\n  height: 0.375rem;\n  background-clip: padding-box;\n  -webkit-border-radius: 0.438rem;\n  border-radius: 0.5rem;\n  background-color: white;\n  -webkit-box-shadow: inset -1px -1px 0px rgb(0 0 0 / 5%),\n  inset 1px 1px 0px rgb(0 0 0 / 5%);\n  box-shadow: inset -1px -1px 0px rgb(0 0 0 / 5%),\n  inset 1px 1px 0px rgb(0 0 0 / 5%);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
